<template>
  <nav v-if="totalPages > 1" aria-label="Page navigation">
    <ul class="c-pagination inline-flex text-sm gap-2">

      <template v-for="page in pages">
        <li v-if="page.breakView"
            :key="'breakView-' + page.pageNumber">
          <span class="flex items-center justify-center w-9 h-9 cursor-default">
            ...
          </span>
        </li>
        <li v-else
            :key="page">
          <button
              @click.prevent="goToPage(page.pageNumber)"
              class="c-pagination__button flex items-center justify-center focus:outline-none w-9 h-9 rounded-xl border border-blue-250 text-blue-250 bg-gray-80"
              :disabled="page.active"
              :class="{ active: page.active }">
            {{ page.pageNumber }}
          </button>
        </li>
      </template>

      <li v-if="totalPages > 1">
        <button
            @click.prevent="nextPage"
            :disabled="currentPage === totalPages"
            class="c-pagination__button flex items-center justify-center focus:outline-none w-9 h-9 rounded-xl border border-blue-250 text-blue-250 bg-gray-80">
          <icon-base viewBox="0 0 5 8" width="8">
            <icon-chevron-right/>
          </icon-base>
        </button>
      </li>
    </ul>
  </nav>
</template>

<script>
import IconChevronRight from "../icons/IconChevronRight.vue";
import IconBase from "../icons/IconBase.vue";

export default {
  components: {IconBase, IconChevronRight},
  props: {
    currentPage: {
      type: Number,
      default: 1
    },
    totalPages: {
      type: Number,
      default: 1
    }
  },

  data() {
    return {
      // pages: {},
      countViewPages: 6, // max кол-во отображаемых страниц пагинации
    }
  },
  computed: {
    pages() {
      const pages = {}
      if (this.totalPages <= this.countViewPages) {
        for (let i = 1; i <= this.totalPages; i++) {
          pages[i] = {
            pageNumber: i,
            active: i === this.currentPage,
            breakView: false // отображать разделитель вместо страницы
          }
        }
      }
      else {
        // 1-2-3-4*-5...>>
        if (this.currentPage < this.countViewPages - 1) {
          for (let i = 1; i <= this.countViewPages; i++) {
            pages[i] = {
              pageNumber: i,
              active: i === this.currentPage,
              breakView: i === this.countViewPages // отображать разделитель вместо страницы
            }
          }
        }
        // 1...5-6*-7...>>
        else if (this.currentPage >= this.countViewPages - 1 && this.totalPages > this.currentPage + 2 ) { // todo вместо 2 this.countViewPages
          pages[0] = {
            pageNumber: 1,
            active: false,
            breakView: false
          }
          const startPage = this.currentPage - 2 // todo this.countViewPages
          const endPage = this.currentPage + 2 // todo this.countViewPages
          for (let i = startPage; i <= endPage; i++) {
            pages[i] = {
              pageNumber: i,
              active: i === this.currentPage,
              breakView: i === startPage || i === endPage
            }
          }
        }
        // 1...7-8*-9-10 >>
        else if (this.currentPage >= this.countViewPages - 1 && this.totalPages <= this.currentPage + 2 ) {
          pages[0] = {
            pageNumber: 1,
            active: false,
            breakView: false
          }
          const startPage = this.totalPages - this.countViewPages + 2 // todo this.countViewPages
          for (let i = startPage; i <= this.totalPages; i++) {
            pages[i] = {
              pageNumber: i,
              active: i === this.currentPage,
              breakView: i === startPage
            }
          }
        }
      }
      return pages
    },
  },

  methods: {
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.$emit('update:current-page', this.currentPage + 1);
      }
    },
    goToPage(pageNumber) {
      this.$emit('update:current-page', pageNumber);
    }
  }
};
</script>
